import { useContext, useEffect, useRef, useState } from 'react';
import './chat.scss';
import { AuthContext } from '../../context/AuthContext';
import apiRequest from '../../lib/apiRequest';
import { format } from 'timeago.js';
import { SocketContext } from '../../context/SocketContext';
import { useNotificationStore } from '../../lib/notificationStore';
import Modal from '../modal/Modal';
import SingleChat from './SingleChat';

function Chat({ chats }) {
  const [chat, setChat] = useState(null);
  const [chatActive, setChatActive] = useState(false); // Состояние модального окна
  const { currentUser } = useContext(AuthContext);
  const { socket } = useContext(SocketContext);
  const messageEndRef = useRef();
  const decrease = useNotificationStore((state) => state.decrease);
  useEffect(() => {
    if (chat?.messages?.length) {
      messageEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [chat]);

const handleOpenChat = async (id, receiver) => {
  try {
    const res = await apiRequest(`/chats/${id}`);
    const data = res.data;

    if (!data || !data.messages || !receiver) {
      console.warn('⚠️ Данные чата неполные или отсутствуют');
      return;
    }

    if (!data.seenBy.includes(currentUser?.user?.id)) {
      decrease();
    }

    setChat({ ...data, receiver });
    setChatActive(true);
  } catch (err) {
    console.log('❌ Ошибка загрузки чата:', err);
  }
};

  if (!currentUser) return <div>Loading...</div>;
  if (!socket) return <div>Socket connection error</div>;

 return (
  <div className="chat">
  {(!chats || chats.length === 0 || chats.every(chat => chat.lastMessage === null)) ? (
  <div className="noChats">You have no messages yet...</div>
) : (
  <div className="messages">
    {chats.map((c) => (
      <div
        className="message"
        key={c.id}
        style={{
          backgroundColor:
            c.seenBy.includes(currentUser?.user?.id) || chat?.id === c.id ? 'white' : '#bddc04ba',
        }}
        onClick={() => handleOpenChat(c.id, c.receiver)}
      >
        <img
  src={c.avatar || '/noproduct.webp'}
  alt="avatar"
  onError={(e) => {
    e.target.onerror = null;
    e.target.src = '/noproduct.webp';
  }}
/>
        <span>{c.receiver.username}</span>
        <p>{c.lastMessage}</p> {/* Показываем, если нет сообщений */}
      </div>
    ))}
  </div>
)}
    <Modal active={chatActive} setActive={setChatActive}>
      <div className="modalMessageButton">
        <button className="button" onClick={() => setChatActive(false)}>X</button>
      </div>
      {chat && <SingleChat chatId={chat.id} post={chat.post} />}
    </Modal>
  </div>
);
}

export default Chat;
